module.exports = __webpack_public_path__ + "static/media/tittle.cc8ab6ca.jpg";